import { View, Pressable, SxProp } from 'dripsy';
import React from 'react';
import { GestureResponderEvent } from 'react-native';
import { Icon, SVGIconList } from '../icons/Icon';

import { TextSmall } from '@/design-system/components/typography/UniTypography';

export interface UniTabButtonProps {
  icon: SVGIconList;
  options?: {
    labelStyles?: SxProp;
    iconStyles?: {
      height?: number;
      width?: number;
      color?: string;
      themeColor?: string;
    };
  };
  label?: string;
  sx?: SxProp;
  onPress: (event: GestureResponderEvent) => void;
}

export const UniIconButton: React.FC<UniTabButtonProps> = ({ label, icon = 'sample', onPress, options, sx }) => {
  return (
    <Pressable onPress={onPress}>
      <View sx={{ ...styles.container, ...sx }}>
        <View sx={styles.containerTop}>
          <Icon
            name={icon}
            height={options?.iconStyles?.height || 20}
            width={options?.iconStyles?.width || 20}
            color={options?.iconStyles?.color}
            themeColor={options?.iconStyles?.themeColor}
          />
        </View>
        {label && (
          <View sx={styles.containerBottom}>
            <TextSmall sx={styles.label}>{label}</TextSmall>
          </View>
        )}
      </View>
    </Pressable>
  );
};

enum StyleName {
  container = 'container',
  containerTop = 'containerTop',
  containerBottom = 'containerBottom',
  label = 'label'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center'
  },
  containerTop: {},
  containerBottom: {
    mt: '$2'
  },
  label: { textAlign: 'center' }
};
